import { useSessionStore } from '@/entities/session';
import { useAssetsExchangeRates } from '@/features/exchange';
import { useAssetsIcons, useHotAssetsDictionary } from '@/shared/api';
import type { BaseAsset } from '@/shared/types';
import { useMemo } from 'react';

export const useRandomCoin = (baseAsset: BaseAsset) => {
  const { isSessionValid } = useSessionStore();

  const { data: hotAssetsData, isLoading: isHotAssetsLoading } =
    useHotAssetsDictionary({ enabled: isSessionValid() });
  const { assetsIconsData, isAssetsIconsLoading } = useAssetsIcons({
    enabled: isSessionValid(),
  });

  const randomAsset = useMemo(() => {
    if (!hotAssetsData?.value?.hotAssets?.length) return null;

    const hotAssets = hotAssetsData.value.hotAssets;
    const index = Math.floor(Math.random() * hotAssets.length);

    return hotAssets[index];
  }, [hotAssetsData]);

  const { data: priceData, isLoading: isPriceLoading } = useAssetsExchangeRates(
    randomAsset ?? '',
    baseAsset,
    isSessionValid()
  );

  const randomAssetIcon =
    randomAsset && assetsIconsData
      ? (assetsIconsData.value?.[randomAsset] ?? null)
      : null;

  const isLoading =
    isHotAssetsLoading ||
    isAssetsIconsLoading ||
    (Boolean(randomAsset) && isPriceLoading);

  return {
    coin: randomAsset,
    icon: randomAssetIcon,
    price: priceData?.priceAsk ?? null,
    isLoading,
  };
};
